export const table_extension = {
  light: {
    tableheadbg: {
      color: "{tableheadbg.400}",
    },
    tabletd01: {
      color: "{tabletd01.400}",
    },
    tabletd02: {
      color: "{tabletd02.400}",
    },
    tableheadercol: {
      color: "{tableheadercol.400}",
    },
    tablegraycol: {
      color: "#6b6b6c",
    },
  },
  dark: {
    tableheadbg: {
      color: "{tableheadbg.500}",
    },
    tabletd01: {
      color: "{tabletd01.500}",
    },
    tabletd02: {
      color: "{tabletd02.500}",
    },
    tableheadercol: {
      color: "{tableheadercol.500}",
    },
    tablegraycol: {
      color: "#adaeb3",
    },
    tableheaderborder: {
      color: "{tableheaderborder.500}",
    },
  },
};
